/** Small inline icons (they take the text colour and are hidden from screen readers). */
export function PencilIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M13.6 2.9a2 2 0 0 1 2.8 0l.7.7a2 2 0 0 1 0 2.8l-8.7 8.7a2 2 0 0 1-.9.5l-3.2.9a.75.75 0 0 1-.9-.9l.9-3.2a2 2 0 0 1 .5-.9l8.8-8.6Zm1.7 1.1a.5.5 0 0 0-.7 0l-1 1 1.4 1.4 1-1a.5.5 0 0 0 0-.7l-.7-.7Zm-1.3 3.5-1.4-1.4-6.7 6.6a.5.5 0 0 0-.1.2l-.5 1.9 1.9-.5a.5.5 0 0 0 .2-.1l6.6-6.7Z" />
    </svg>
  );
}

export function PlusIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M10 3.5a.75.75 0 0 1 .75.75v5h5a.75.75 0 0 1 0 1.5h-5v5a.75.75 0 0 1-1.5 0v-5h-5a.75.75 0 0 1 0-1.5h5v-5A.75.75 0 0 1 10 3.5Z" />
    </svg>
  );
}

export function CloseIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M5.3 5.3a.75.75 0 0 1 1.06 0L10 8.94l3.64-3.64a.75.75 0 1 1 1.06 1.06L11.06 10l3.64 3.64a.75.75 0 1 1-1.06 1.06L10 11.06 6.36 14.7a.75.75 0 0 1-1.06-1.06L8.94 10 5.3 6.36a.75.75 0 0 1 0-1.06Z" />
    </svg>
  );
}

export function UploadIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M10 2.5a.75.75 0 0 1 .53.22l3.5 3.5a.75.75 0 1 1-1.06 1.06l-2.22-2.22v7.69a.75.75 0 0 1-1.5 0V5.06L7.03 7.28a.75.75 0 0 1-1.06-1.06l3.5-3.5A.75.75 0 0 1 10 2.5ZM3.75 12a.75.75 0 0 1 .75.75v2c0 .41.34.75.75.75h9.5c.41 0 .75-.34.75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 14.75 17h-9.5A2.25 2.25 0 0 1 3 14.75v-2a.75.75 0 0 1 .75-.75Z" />
    </svg>
  );
}
